// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action } from '@ngrx/store';
import { ScopeCategory, ScopeConstraint } from '@app/core';

export enum ScopesActionTypes {
  SCOPE_CATEGORIES_LOADING = '[Scope] SCOPE_CATEGORIES_LOADING',
  SCOPE_CATEGORIES_LOAD_COMPLETE = '[Scope] SCOPE_CATEGORIES_LOAD_COMPLETE',
  SCOPE_CATEGORIES_LOAD_FAILED = '[Scope] SCOPE_CATEGORIES_LOAD_FAILED',
  SCOPE_CONSTRAINTS_LOADING = '[Scope] SCOPE_CONSTRAINTS_LOADING',
  SCOPE_CONSTRAINTS_LOAD_COMPLETE = '[Scope] SCOPE_CONSTRAINTS_LOAD_COMPLETE',
  SCOPE_CONSTRAINTS_LOAD_FAILED = '[Scope] SCOPE_CONSTRAINTS_LOAD_FAILED'
}

export class LoadingScopeCategoriesAction implements Action {
  readonly type = ScopesActionTypes.SCOPE_CATEGORIES_LOADING;
  constructor() {}
}

export class CompleteLoadScopeCategoriesAction implements Action {
  readonly type = ScopesActionTypes.SCOPE_CATEGORIES_LOAD_COMPLETE;
  constructor(public payload: ScopeCategory[]) {
    this.payload = payload;
  }
}

export class FailLoadScopeCategoriesAction implements Action {
  readonly type = ScopesActionTypes.SCOPE_CATEGORIES_LOAD_FAILED;
  constructor() {}
}

export class LoadingScopeConstraintsAction implements Action {
  readonly type = ScopesActionTypes.SCOPE_CONSTRAINTS_LOADING;
  constructor(public payload: string) {
    this.payload = payload;
  }
}

export class CompleteLoadScopeConstraintsAction implements Action {
  readonly type = ScopesActionTypes.SCOPE_CONSTRAINTS_LOAD_COMPLETE;
  constructor(public payload: { categoryId: string; constraints: ScopeConstraint[] }) {
    this.payload = payload;
  }
}

export class FailLoadScopeConstraintsAction implements Action {
  readonly type = ScopesActionTypes.SCOPE_CONSTRAINTS_LOAD_FAILED;
  constructor(public payload: string) {
    this.payload = payload;
  }
}

export type ScopesActionsUnion =
  | LoadingScopeCategoriesAction
  | CompleteLoadScopeCategoriesAction
  | FailLoadScopeCategoriesAction
  | LoadingScopeConstraintsAction
  | CompleteLoadScopeConstraintsAction
  | FailLoadScopeConstraintsAction;



// WEBPACK FOOTER //
// ./src/app/access-management/state/role-scope.actions.ts